import './App.css';
import Header from './components/Header';
import Quiz from './components/Quiz';

function App() {
  return (
    <div className="App">
    <Header/>
    <Quiz/>
    </div>
  );
}

export default App;
